// extracted by mini-css-extract-plugin
export default {"smallImage":"styles_smallImage__wYvK5","active":"styles_active__T+HCH"};